import ApiService from './api.service';

class EquivalenciasProveedorService extends ApiService {
  constructor() {
    super('/productos/equivalencias-proveedor');
  }

  async listar() {
    const res = await this.get('');
    if (res.status >= 400) {
      throw new Error(res.data?.message || 'No se pudieron leer las equivalencias');
    }
    if (!Array.isArray(res.data?.data)) {
      throw new Error(res.data?.message || 'La respuesta no trae las relaciones');
    }
    return res.data.data;
  }

  async proponer(payload) {
    const res = await this.post('/proponer', payload);
    if (res.status >= 400) {
      throw new Error(res.data?.message || 'No se pudo armar la propuesta');
    }
    return res.data?.data;
  }

  async simularPropuesta(payload) {
    const res = await this.post('/propuesta-ia', payload);
    if (res.status >= 400) {
      throw new Error(res.data?.message || 'No se pudo simular la propuesta');
    }
    return res.data?.data;
  }

  async crear(payload) {
    const res = await this.post('', payload);
    if (res.status >= 400) {
      throw new Error(res.data?.message || 'No se pudo registrar la relación');
    }
    return { relacion: res.data?.data || null, auditoria: res.data?.auditoria || null };
  }

  async decidir(id, payload) {
    const res = await this.put(`/${id}`, payload);
    if (res.status >= 400) {
      throw new Error(res.data?.message || 'No se pudo guardar la decisión');
    }
    return { relacion: res.data?.data || null, auditoria: res.data?.auditoria || null };
  }
}

const equivalenciasProveedorService = new EquivalenciasProveedorService();
export default equivalenciasProveedorService;
